// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a440150e","455":"fee4d976","977":"61609c3b"}[chunkId] + ".chunk.js";
};